var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-404"},[_c('img',{attrs:{"src":_vm.fontAssetsURL("404.png"),"alt":""}}),_c('p',[_vm._v(" 您访问的页面不存在哦,点击 "),_c('router-link',{attrs:{"to":{ name: 'index' }}},[_vm._v("返回首页")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }